import { createAsyncThunk } from '@reduxjs/toolkit';
import ProviderManager from '../../../provider/providerManager';
import { showAppLoader, hideAppLoader } from '../../Shared/Loader/LoaderSlice';
import { setAction, redirectToLogin, clearSubscribers, clearSelection, goToPage, setLoader, setErrorPage, setPopUp, setSelectedTab, setSelectedSubscriber, reportDWH, reportAnalytics, setSelectedPackage, setIsCameFromSelfCarePage, setProvisioningPage, setProvisioningPageComplete, setProvisioningPageTimeout, incrementPollingCount } from './PremiumPackagesCatalogSlice';
import { setSelectedService } from '../../Page/SelfCarePage/SelfCareSlice';
import { setCurrentProcess, setSelectedTvSubscriber, setRegistrationParams } from '../StreamingRegistrationRedirectionBlock/StreamingRegistrationSlice';
import { StreamingRegistrationProcessTypes, DISNEY_REGISTRATION_PARAMS, HBO_REGISTRATION_PARAMS } from '../StreamingRegistrationRedirectionBlock/utils/constants';
import { getSessionId } from '../../../utilities/userStorageAPI/localStorageAPI';
import tvClock from './images/tvClock.svg';
import Config from 'app/Config';
export const checkInfo = createAsyncThunk('premiumPackagesCatalog/checkInfo', async (data, thunkAPI) => {
    try {
        const state = thunkAPI.getState().premiumPackagesCatalog;
        if (state.popup.isDisplay) {
            thunkAPI.dispatch(setPopUp({ isDisplay: false, type: '' }));
        }

        if (state.tvSubscribers == null) {
            thunkAPI.dispatch(getTvSubscribersAsync())
        }
        else {
            thunkAPI.dispatch(hideAppLoader());
            if (state.tvSubscribers?.length == 0) {
                thunkAPI.dispatch(reportDWH({ actionType: 'GetTvUsers', status: 'Ongoing', messageText: 'No TV Users' }));
                thunkAPI.dispatch(setErrorPage({ isDisplay: true, id: '0', type: 'noTvSubscription', isOpenWorkOrder: true, description: 'not have tv subscription' }));
            }
            else if (state.tvSubscribers?.length == 1) {
                if (!state.tvSubscribers[0].isJetCustomer) {
                    thunkAPI.dispatch(reportDWH({ actionType: 'GetTvUsers', status: 'Ongoing', messageText: 'No JET Customer' }));
                    thunkAPI.dispatch(setErrorPage({ isDisplay: true, id: '0', type: 'isNotJetCustomer', isOpenWorkOrder: true, description: 'not allowed' }));
                }
                else if (!state.tvSubscribers[0].isActive) {
                    thunkAPI.dispatch(setErrorPage({ isDisplay: true, id: '0', type: 'notAllowed', isOpenWorkOrder: true, description: 'not allowed' }));
                }
                else if (state.tvSubscribers[0].hasDebt && state.tvSubscribers[0].hasPaymentMethodIssue) {
                    thunkAPI.dispatch(setErrorPage({ isDisplay: true, id: '0', type: 'hasDebtAndHasPaymentMethodIssue', isOpenWorkOrder: true, description: 'has debt and has payment method issue' }));
                }
                else if (state.tvSubscribers[0].hasDebt) {
                    thunkAPI.dispatch(setErrorPage({ isDisplay: true, id: '0', type: 'hasDebt', isOpenWorkOrder: true, description: 'has debt' }));
                }
                else if (state.tvSubscribers[0].hasPaymentMethodIssue) {
                    thunkAPI.dispatch(setErrorPage({ isDisplay: true, id: '0', type: 'hasPaymentMethodIssue', isOpenWorkOrder: true, description: 'has payment method issue' }));
                }
                else {
                    if ((!state.availablePackages || !state.installedPackages) ||
                        (state.availablePackages?.length == 0 && state.installedPackages?.length == 0)) {
                        thunkAPI.dispatch(getCatalogAsync());
                    }
                    else if (state.availablePackages?.length == 0) {
                        thunkAPI.dispatch(setSelectedTab("existingPackages"));
                        thunkAPI.dispatch(goToPage("allPackagesInstalledPage"));
                    }
                    else {
                        thunkAPI.dispatch(setAction(''));
                        thunkAPI.dispatch(clearSelection())
                        thunkAPI.dispatch(setSelectedTab("newPackages"));
                        thunkAPI.dispatch(goToPage("packagesPage"));
                    }
                }
            }
            else if (state.tvSubscribers?.length > 1 && !state.selectedSubscriber) {
                thunkAPI.dispatch(goToPage("subscriberListPage"));
            }
            else if (state.selectedSubscriber) {
                if ((!state.availablePackages || !state.installedPackages) ||
                    (state.availablePackages?.length == 0 && state.installedPackages?.length == 0)) {
                    thunkAPI.dispatch(getCatalogAsync());
                }
                else if (state.availablePackages?.length == 0) {
                    thunkAPI.dispatch(setSelectedTab("existingPackages"));
                    thunkAPI.dispatch(goToPage("allPackagesInstalledPage"));
                }
                else {
                    thunkAPI.dispatch(setAction(''));
                    thunkAPI.dispatch(clearSelection())
                    thunkAPI.dispatch(setSelectedTab("newPackages"));
                    thunkAPI.dispatch(goToPage("packagesPage"));
                }
            }
        }

    } catch (error) {
    }
    finally {

    }
});

export const redirectToLoginAsync = createAsyncThunk('premiumPackagesCatalog/redirectToLoginAsync', async (data, thunkAPI) => {
    try {
        const authentication = thunkAPI.getState().authentication;
        if (!authentication?.loginData?.isFullAuthenticated) {
            thunkAPI.dispatch(clearSubscribers());
            const returnUrl = encodeURIComponent(window.location.pathname + window.location.hash.toLowerCase());
            thunkAPI.dispatch(redirectToLogin({ returnUrl: returnUrl, cancelUrl: '', template: '' }))
        }
    } catch (error) {
    }
    finally {
    }
});
export const getTvSubscribersForRegistration = createAsyncThunk('premiumPackagesCatalog/getTvSubscribersForRegistration', async (data, thunkAPI) => {
    try {
        const result = await ProviderManager.getProviderData('getTVSubscribers', []);
        const { tvSubscriberList } = result?.Body || {};

        return {
            tvSubscriberList: result?.Body?.tvSubscriberList,
            error: false,
        };
    } catch (error) {
        return {
            tvSubscriberList: [],
            error: true,
        };
    }
});
export const getTvSubscribersAsync = createAsyncThunk('premiumPackagesCatalog/getTvSubscribersAsync', async (data, thunkAPI) => {
    try {
        const selfcarePage = thunkAPI.getState().selfcarePage;

        thunkAPI.dispatch(showAppLoader());
        const result = await ProviderManager.getProviderData('getTVSubscribers', []);
        thunkAPI.dispatch(hideAppLoader());

        const tvSubscribers = result?.Body?.tvSubscriberList;
        if (tvSubscribers.length > 1) {
            const isSelectedService = selfcarePage.selectedService !== null && Object.keys(selfcarePage.selectedService).length !== 0;
            if (isSelectedService && selfcarePage.selectedSubscriber.ban) {
                const selectedSubscriber = tvSubscribers.find(x => x.ban == selfcarePage.selectedSubscriber.ban);
                checkSubscriber(selectedSubscriber, thunkAPI);
            }
            else {
                thunkAPI.dispatch(goToPage("subscriberListPage"));
            }
        }
        else if (tvSubscribers.length == 1) {
            checkSubscriber(tvSubscribers[0], thunkAPI);
        }
        else {
            thunkAPI.dispatch(reportDWH({ actionType: 'GetTvUsers', status: 'Ongoing', messageText: 'No TV Users' }));
            thunkAPI.dispatch(reportAnalytics({
                eventCategory: 'premium_packages',
                eventAction: 'visibility_2',
                eventLabel: 'element_3',
            }));
            thunkAPI.dispatch(setErrorPage({ isDisplay: true, id: '0', type: 'noTvSubscription', isOpenWorkOrder: true, description: 'not have tv subscription' }));
        }
        return result?.Body;
    } catch (error) {
        thunkAPI.dispatch(hideAppLoader());
        thunkAPI.dispatch(setErrorPage({ isDisplay: true, id: '0', type: 'generalError', isOpenWorkOrder: true, description: 'error at getTvSubscribersAsync' }));
    }
    finally {
    }
});


export const getCatalogAsync = createAsyncThunk('premiumPackagesCatalog/getCatalogAsync', async (data, thunkAPI) => {
    const state = thunkAPI.getState().premiumPackagesCatalog;
    const selfcarePage = thunkAPI.getState().selfcarePage;
    const action = state.action;
    const stateLoader = thunkAPI.getState().loader;
    try {

        if (!stateLoader.isLoading) {
            thunkAPI.dispatch(showAppLoader());
        }

        const userDetails = thunkAPI.getState().authentication?.loginData?.userDetails;
        const selectedSubscriber = state.selectedSubscriber;
        const productList = action == '' ? getPackagesToAddOrRemove(state) : [];
        const productWorldList = getProductWorldList(state.subPackages?.selected);

        const params = {
            offerId: selectedSubscriber.offerId,
            saleType: "premiumPackages",
            infraType: "",
            productList: productList,
            productWorldList: productWorldList,
            calcSupplyMethod: false,
            selectedAddress: null,
            general: {
                orderType: "change",
            },
            personalInfo: {
                idNumber: userDetails.IDNumber,
                otpPhone: userDetails.contactNumber,
                ban: selectedSubscriber.ban,
                accountId: selectedSubscriber.consumerId
            },
        };
        const result = await ProviderManager.getProviderData('getPremiumPackagesSalePrices', params);
        thunkAPI.dispatch(hideAppLoader());

        const response = setPremiumPackageResponse(result);

        if (state.page == '' || state.page == 'subscriberListPage') {
            thunkAPI.dispatch(clearSelection());

            let selectedService = selfcarePage.selectedService;

            //-----------------------------------------------------
            const params = new URLSearchParams(window.location.search);
            const packageid = params.get('packageid');
            if (packageid) {
                thunkAPI.dispatch(reportDWH({ actionType: 'NewsletterLinkEntry', status: 'Ongoing', messageText: 'PackageOrWorldTransitionDisplayed' }));
                const premiumPackage = result?.Body?.saleCatalog?.premiumPackages?.find(x => x.name == packageid);
                if (premiumPackage) {
                    selectedService = premiumPackage;
                    thunkAPI.dispatch(reportDWH({ actionType: 'NewsletterLinkEntry', status: 'Completed', messageText: 'PackageOrWorldTransitionSucceeded' }));
                }
                else {
                    thunkAPI.dispatch(reportDWH({ actionType: 'NewsletterLinkEntry', status: 'Error', messageText: 'PackageOrWorldTransitionfailure' }));
                }
            }
            //-----------------------------------------------------

            if (selectedService !== null && Object.keys(selectedService).length !== 0) {
                let packageExist = false;
                if (selectedService.action?.toUpperCase() == "EXISTING") {
                    const selectedExistPackage = isSelfCarePackageExist(response.installedPackages, selectedService);
                    if (selectedExistPackage) {
                        packageExist = true;
                        thunkAPI.dispatch(setIsCameFromSelfCarePage(true));
                        thunkAPI.dispatch(setSelectedPackage(selectedExistPackage));
                        thunkAPI.dispatch(goToPage('packageExistPage'));
                    }
                }
                else {
                    const selectedAvailablePackage = isSelfCarePackageExist(response.availablePackages, selectedService);
                    if (selectedAvailablePackage) {
                        packageExist = true;
                        thunkAPI.dispatch(setIsCameFromSelfCarePage(true));
                        thunkAPI.dispatch(setSelectedPackage(selectedAvailablePackage));
                        if (selectedAvailablePackage.isPremiumPackagesWorld) {
                            thunkAPI.dispatch(goToPage('packagesWorldPage'));
                        }
                        else if (selectedAvailablePackage.vasList?.length > 0) {
                            thunkAPI.dispatch(goToPage('packageRoutesPage'));
                        }
                        else {
                            thunkAPI.dispatch(goToPage('packageBasicPage'));
                        }
                    }
                }

                if (!packageExist) {
                    thunkAPI.dispatch(setErrorPage({ isDisplay: true, id: '0', type: 'generalError', isOpenWorkOrder: true, description: 'package not found : ' + selectedService.name }));
                }

                thunkAPI.dispatch(setSelectedService({}));
            }
            else {
                if (response.availablePackages?.length == 0 && response.installedPackages?.length == 0) {
                    thunkAPI.dispatch(setErrorPage({ isDisplay: true, id: '0', type: 'generalError', isOpenWorkOrder: true, description: 'get catalog error' }));
                }
                else if (response.availablePackages?.length == 0) {
                    thunkAPI.dispatch(setSelectedTab("existingPackages"));
                    thunkAPI.dispatch(goToPage("allPackagesInstalledPage"));
                }
                else {
                    thunkAPI.dispatch(setSelectedTab("newPackages"));
                    thunkAPI.dispatch(goToPage("packagesPage"));
                }
            }
        }
        else if (action != '') {// if action == add or remove
            if (response.availablePackages?.length == 0 && response.installedPackages?.length == 0) {
                thunkAPI.dispatch(setErrorPage({ isDisplay: true, id: '0', type: 'generalError', isOpenWorkOrder: true, description: 'get catalog error' }));
            }
            else if (response.availablePackages?.length == 0) {
                thunkAPI.dispatch(setSelectedTab("existingPackages"));
                thunkAPI.dispatch(goToPage("allPackagesInstalledPage"));
            }
            else {
                if (response.installedPackages?.length > 0) {
                    thunkAPI.dispatch(setSelectedTab("existingPackages"));
                }
                else {
                    thunkAPI.dispatch(setSelectedTab("newPackages"));
                }
                thunkAPI.dispatch(goToPage("packagesPage"));
            }
        }

        return response;
    } catch (error) {
        thunkAPI.dispatch(hideAppLoader());
        thunkAPI.dispatch(setErrorPage({ isDisplay: true, id: '0', type: 'generalError', isOpenWorkOrder: true, description: 'get catalog error' }));
    }
    finally {
        thunkAPI.dispatch(setAction(''));
    }
});

const handleHboAddSuccess = (thunkAPI, additionalResultValue) => {
    const { isHboMax, orderType, hboStatus } = additionalResultValue || {};
    if (isHboMax !== 'true') return false;

    thunkAPI.dispatch(setRegistrationParams(HBO_REGISTRATION_PARAMS));

    if (orderType === 'add') {
        thunkAPI.dispatch(setProvisioningPage({
            title: 'ברגעים אלו אנחנו עובדים\nעל התקנת החבילה שלך',
            subtitle: 'לפני שנתחיל את הבינג\u05f3\nחשוב להשלים את יצירת החשבון\nבאתר HBO Max\n\nכמה רגעים ונעביר אותך...',
            actionBtnText: 'ל- HBO Max',
            pollingIntervalMs: 10000,
            maxPollingAttempts: 6,
        }));
        thunkAPI.dispatch(goToPage('provisioningPage'));
        return true;
    }
    if (orderType === 'change' && hboStatus === 'B') {
        thunkAPI.dispatch(setSelectedTvSubscriber(thunkAPI.getState().premiumPackagesCatalog.selectedSubscriber?.subscriberNo));
        thunkAPI.dispatch(setCurrentProcess(StreamingRegistrationProcessTypes.PACKAGE_EXIST));
        thunkAPI.dispatch(setPopUp({ isDisplay: true, type: 'hboChangeSuccess' }));
        return true;
    }
    if (orderType === 'change' && ( hboStatus === 'A' || hboStatus === 'C')) {
        thunkAPI.dispatch(setPopUp({ isDisplay: true, type: 'hboChangePlanSuccess' }));
        return true;
    }
    return false;
};

const handleHboAddFailure = (thunkAPI, additionalResultValue) => {
    if (additionalResultValue?.isHboMax !== 'true') return false;
    thunkAPI.dispatch(setPopUp({ isDisplay: true, type: 'hboChangePlanFailed' }));
    return true;
};

const handleDisneyAddSuccess = (thunkAPI, additionalResultValue) => {
    const { isDisney, orderType, disneyStatus } = additionalResultValue || {};
    if (isDisney !== 'true') return false;
        thunkAPI.dispatch(setRegistrationParams(DISNEY_REGISTRATION_PARAMS));
        thunkAPI.dispatch(setProvisioningPage({
            title: 'ברגעים אלו אנחנו עובדים\nעל התקנת החבילה שלך',
            subtitle: 'לפני שנתחיל את הבינג\u05f3\nחשוב להשלים את יצירת החשבון\nבאתר דיסני+\n\nכמה רגעים ונעביר אותך...',
            actionBtnText: 'לדיסני+',
            pollingIntervalMs: 10000,
            maxPollingAttempts: 6,
        }));
        thunkAPI.dispatch(goToPage('provisioningPage'));
        return true;
};

const handleDisneyAddFailure = (thunkAPI, additionalResultValue) => {
    if (additionalResultValue?.isDisney !== 'true') return false;
    thunkAPI.dispatch(setPopUp({ isDisplay: true, type: 'disneyChangePlanFailed' }));
    return true;
};

export const premiumPackageActionAsync = createAsyncThunk('premiumPackagesCatalog/premiumPackageAction', async (data, thunkAPI) => {
    try {
        const state = thunkAPI.getState().premiumPackagesCatalog;

        thunkAPI.dispatch(setAction(data.action))
        if (data.action == "add") {
            thunkAPI.dispatch(reportDWH({ actionType: 'Package Page', status: 'Ongoing', messageText: 'Package Page Buy Button Clicked' }));

        }
        else {
            thunkAPI.dispatch(reportDWH({ actionType: 'Existing Package Page', status: 'Ongoing', messageText: 'Package Page Delete Button Clicked' }));
        }

        const productList = getPackagesToAddOrRemove(state);

        const loaderTitle = getLoaderTitle(data.action, productList.length);
        thunkAPI.dispatch(setLoader({ isDisplay: true, title: loaderTitle }));

        if (data.action == "add") {
            thunkAPI.dispatch(reportAnalytics({
                eventCategory: 'premium_packages',
                eventAction: 'visibility_14',
                eventLabel: 'element_15',
            }));
        }
        else {
            thunkAPI.dispatch(reportAnalytics({
                eventCategory: 'premium_packages',
                eventAction: 'visibility_7',
                eventLabel: 'element_8',
            }));
        }

        const userDetails = thunkAPI.getState().authentication?.loginData?.userDetails;
        const selectedSubscriber = state.selectedSubscriber;
        const selectedPackage = state.selectedPackage;

        let params = {
            saleType: "premiumPackages",
            offerId: selectedSubscriber.offerId,
            infraType: null,
            internetSpeed: null,
            productList: productList,
            calcSupplyMethod: false,
            general: {
                supplyMethod: '', //Technician|Delivery|No Supply|SelfPickUp
                calcPriceInd: false,
                orderType: 'change',
                serviceAction: data.action?.toUpperCase(), //ADD/REMOVE
                billingAccountIdType: '',
            },
            customerExposure: null,
            selectedAddress: null,
            workAddress: null,
            personalInfo: {
                isCustomerExists: true,
                idNumber: userDetails.IDNumber,
                otpPhone: userDetails.contactNumber,
                firstName: userDetails.firstName,
                lastName: userDetails.lastName,
                ban: selectedSubscriber.ban,
                accountId: selectedSubscriber.consumerId,
            },
            techVisitInfo: null,
            haveTechnicianVisit: false,
        };
        const result = await ProviderManager.getProviderData('premiumPackageCatalogAction', params);
        const isSuccess = result.Body.isSuccess;

        if (isSuccess) {
            if (data.action == "add") {
                thunkAPI.dispatch(reportDWH({ actionType: 'PackageAdded', status: 'Completed', messageText: 'User ADD premium package' }));
                const hboHandled = handleHboAddSuccess(thunkAPI, result.Body.additionalResultValue);
                const disneyHandled = handleDisneyAddSuccess(thunkAPI, result.Body.additionalResultValue);
                if (!hboHandled && !disneyHandled) {
                    thunkAPI.dispatch(setPopUp({ isDisplay: true, type: "installedSuccess", packagesCount: productList.length }));
                }
            }
            else {
                thunkAPI.dispatch(reportDWH({ actionType: 'PackageRemoved', status: 'Completed', messageText: 'User DELETE premium package' }));
                thunkAPI.dispatch(reportAnalytics({
                    eventCategory: 'premium_packages',
                    eventAction: 'visibility_8',
                    eventLabel: 'element_9',
                }));
                thunkAPI.dispatch(setPopUp({ isDisplay: true, text: selectedPackage?.cmsData?.selfCare?.removedRemarkTextPopup, type: "removedSuccess" }));
            }
            thunkAPI.dispatch(clearSelection());
        }
        else {
            thunkAPI.dispatch(setAction(''));
            if (data.action == "add") {
                thunkAPI.dispatch(reportDWH({ actionType: 'PackageAdded', status: 'Error', messageText: 'User ADD premium package' }));
                const hboHandled = handleHboAddFailure(thunkAPI, result.Body.additionalResultValue);
                const disneyHandled = handleDisneyAddFailure(thunkAPI, result.Body.additionalResultValue);
                if (!hboHandled && !disneyHandled) {
                    thunkAPI.dispatch(setPopUp({ isDisplay: true, type: "installedFailed", packagesCount: productList.length }));
                }
            }
            else {
                thunkAPI.dispatch(reportDWH({ actionType: 'PackageRemoved', status: 'Error', messageText: 'User DELETE premium package' }));
                thunkAPI.dispatch(reportAnalytics({
                    eventCategory: 'premium_packages',
                    eventAction: 'visibility_9',
                    eventLabel: 'element_10',
                }));
                thunkAPI.dispatch(setPopUp({ isDisplay: true, type: "removedFailed" }));
            }
        }
        thunkAPI.dispatch(setLoader({ isDisplay: false, title: '' }));

        return result?.Body;
    } catch (error) {
        thunkAPI.dispatch(setLoader({ isDisplay: false, title: '' }));
        if (data.action == "add") {
            thunkAPI.dispatch(setPopUp({ isDisplay: true, type: "installedFailed" }));
        }
        else {
            thunkAPI.dispatch(setPopUp({ isDisplay: true, type: "removedFailed" }));
        }
    }
});

export const checkProvisioningStatusAsync = createAsyncThunk('premiumPackagesCatalog/checkProvisioningStatus', async (data, thunkAPI) => {
    try {
        const state = thunkAPI.getState().premiumPackagesCatalog;
        const selectedSubscriber = state.selectedSubscriber;
        const tvSubscribers = thunkAPI.getState().selfcarePage?.subscribersByProduct?.TV ?? [];
        const tvSubscriber = tvSubscribers.find(s => s.ban === selectedSubscriber?.ban);
        const sessionId = getSessionId();
        const connectClientName = thunkAPI.getState().streamingRegistrationSlice?.connectClientName ?? 'HBO';
        const isDisney = connectClientName === 'DISNEY';
        const statusAction = isDisney ? 'GetDisneyStatus' : 'GetHbomaxStatus';
        const streamingBrand = isDisney ? 'דיסני+' : 'HBO Max';

        const jsonString = JSON.stringify({
            SourceId: 'CELLCOM_WEB_SITE',
            MessageId: sessionId,
            Action: statusAction,
            CRMCutomerId: tvSubscriber?.productSubscriberNo,
        });

        const params = {
            action: statusAction,
            method: 'TV',
            sourceId: 'CELLCOM_WEB_SITE',
            jsonString,
        };

        const result = await ProviderManager.getProviderData('invokeAction', params);
        const rawJsonString = result?.Body?.Body?.Response?.JsonString;
        const responseJson = typeof rawJsonString === 'string'
            ? JSON.parse(rawJsonString)
            : rawJsonString;
        const actionCode = responseJson?.ActionCode;
        const wasConnected = responseJson?.WasConnected === true || responseJson?.wasConnected === true;

        if (actionCode === 1000) {
            thunkAPI.dispatch(setSelectedTvSubscriber(thunkAPI.getState().premiumPackagesCatalog.selectedSubscriber?.subscriberNo));
            thunkAPI.dispatch(setCurrentProcess(StreamingRegistrationProcessTypes.PACKAGE_NOT_EXIST));

            if (wasConnected) {
                thunkAPI.dispatch(setProvisioningPageComplete({
                    title: 'החבילה הותקנה בהצלחה',
                    wasConnected: true,
                    actionBtnText: isDisney ? 'לדיסני+' : 'ל- HBO Max',
                }));
            } else {
                thunkAPI.dispatch(setProvisioningPageComplete({
                    title: 'החבילה הותקנה בהצלחה',
                    subtitle: `חשוב להשלים את יצירת החשבון\nבאתר ${streamingBrand}\nכדי לקבל גישה לתכנים של ${streamingBrand}`,
                    actionBtnText: isDisney ? 'לדיסני+' : 'ל- HBO Max',
                    wasConnected: false,
                }));
            }
        } else if (actionCode === 1001) {
            thunkAPI.dispatch(setPopUp({ isDisplay: true, type: 'provisioningFailed' }));
        } else if (actionCode === 1002 || actionCode === 1003) {
            const { pollingCount, maxPollingAttempts } = thunkAPI.getState().premiumPackagesCatalog.provisioningPage;
            if (pollingCount + 1 >= maxPollingAttempts) {
                thunkAPI.dispatch(setProvisioningPageTimeout({
                    title: 'נראה שייקח לנו \nעוד כמה דקות',
                    subtitle: `במקום להמתין, נשלח לך בעוד כמה דקות\nסמס עם לינק להשלמת התהליך ב-${streamingBrand}`,
                    timeoutImage: tvClock,
                }));
            } else {
                thunkAPI.dispatch(incrementPollingCount());
            }
        }

        return result?.Body;
    } catch (error) {
        thunkAPI.dispatch(setPopUp({ isDisplay: true, type: 'provisioningFailed' }));
    }
});

export const getTvSubscribersForHbo = getTvSubscribersForRegistration;

const getPackagesToAddOrRemove = (state) => {
    var packages = [];
    if (state.page == 'packagesWorldPage') {
        state.subPackages?.selected?.map((item) => {
            packages.push({ name: item.name, count: 1 });
        });
    }
    else if (state.page == 'packageRoutesPage') {
        if (state.selectedPackageRoute) {
            packages.push({ name: state.selectedPackageRoute.name, count: 1 });
        }
    }
    else if (state.page == 'packageBasicPage') {
        if (state.selectedPackage) {
            packages.push({ name: state.selectedPackage.name, count: 1 });
        }
    }
    else if (state.page == 'packageExistPage') {
        if (state.selectedPackage) {
            let selectedPackage = state.selectedPackage;
            if (selectedPackage.vasList) {
                let existingPackage = selectedPackage.vasList?.find(x => x.action == "Existing");
                if (existingPackage) {
                    selectedPackage = existingPackage;
                }
            }
            packages.push({ name: selectedPackage.name, count: 0 });
        }
    }

    return packages;
}

const getLoaderTitle = (action, packagesCount) => {
    if (action == "add") {
        if (packagesCount == 1) {
            return 'עובדים על התקנת החבילה \n החדשה שלכם';
        }
        else {
            return 'עובדים על התקנת החבילות \n החדשות שלכם';
        }
    }
    else {
        return 'עובדים על הבקשה שלך';
    }
}

const setPremiumPackageResponse = (result) => {
    let availablePackages = []
    let installedPackages = [];

    result?.Body?.saleCatalog?.premiumPackages?.map((premiumPackage) => {
        if (premiumPackage.isPremiumPackagesWorld) {
            premiumPackage.premiumPackages = premiumPackage.premiumPackages.filter((x) => x.vasList == null && x.cmsData?.selfCare != null && !x.cmsData?.selfCare?.existedPackageOnly);
            if (premiumPackage.premiumPackages?.length > 1) {
                var hasAvailablePackage = premiumPackage.premiumPackages?.filter(x => (x.action == '' || x.action?.toUpperCase() == 'ADD'));
                if (hasAvailablePackage.length >= 1) {
                    availablePackages.push(premiumPackage);
                }
            }
        }
        else {
            if (premiumPackage.action == '') {
                if (premiumPackage.vasList?.length > 0) {
                    let existingVas = premiumPackage.vasList?.find(x => x.action == "Existing");
                    if (existingVas) {
                        installedPackages.push(premiumPackage);
                    }
                    else {
                        if (premiumPackage.cmsData?.selfCare && !premiumPackage.cmsData?.selfCare?.existedPackageOnly) {
                            availablePackages.push(premiumPackage);
                        }
                    }
                }
                else {
                    if (premiumPackage.cmsData?.selfCare && !premiumPackage.cmsData?.selfCare?.existedPackageOnly) {
                        availablePackages.push(premiumPackage);
                    }
                }
            }
            else if (premiumPackage.action == "Existing") {
                installedPackages.push(premiumPackage);
            }
        }

    })

    availablePackages = availablePackages?.filter((premiumPackage) => {
        let isActive = false;
        if (premiumPackage.isPremiumPackagesWorld) {
            isActive = true;
        }
        else {
            let isInWorld = availablePackages?.some(x => x.isPremiumPackagesWorld && x.premiumPackages?.some(x => x.name == premiumPackage.name));
            isActive = !isInWorld;
        }
        if (isActive) {
            premiumPackage.priceItemList = buildPriceItemList(premiumPackage.priceItemList);
            premiumPackage.premiumPackages?.map((item) => {
                item.priceItemList = buildPriceItemList(item.priceItemList, false);
            });
        }
        return isActive;
    });

    const response = {
        availablePackages: availablePackages,
        installedPackages: installedPackages,
        hboStatus: result?.Body?.saleCatalog?.hboStatus ?? null,
        disneyStatus: result?.Body?.saleCatalog?.disneyStatus ?? null,
    }

    return response;
}

function buildPriceItemList(priceItemList) {
    let priceItems = priceItemList;
    if (priceItems?.length > 0) {
        priceItems?.map((item) => {
            if (item.amount) {
                if (parseInt(item.amount) == 1) {
                    item.priceText = 'לחודש הראשון';
                }
                else if (parseInt(item.amount) == 2) {
                    item.priceText = 'לחודשיים הראשונים';
                }
                else {
                    item.priceText = 'ל' + (item.amount + ' חודשים') + ' ראשונים';
                }
                item.totalPrePriceText = 'מנוי חודשי מתחדש';
                item.totalPriceText = item.priceText;
            } else if (item.to == 0 && item.from == item.to) { //from and to = 0
                item.priceText = '';
            } else if (((item.from == 0 || item.from == 1) && item.from < item.to)) {
                const monthsText = ['חודש', 'חודשיים', (item.to + ' חודשים')]
                const monthText = item.to == 2 ? monthsText[1] : monthsText[2];
                item.priceText = item.to == 1 ? 'לחודש הראשון' : ' ל' + monthText + ' חודשים ';
                item.totalPrePriceText = 'סה"כ חיוב חודשי ל ' + item.priceText;
                item.totalPriceText = 'לחודש';
            } else if (item.to == 0 && item.from > item.to) {
                if (item.from == 1) {
                    item.priceText = 'לחודש';
                    item.totalPrePriceText = 'סה"כ לתשלום';
                }
                else {
                    item.priceText = 'ולאחר מכן';
                    item.totalPrePriceText = 'סה"כ חיוב חודשי לאחר מכן';
                }
                item.totalPriceText = 'לחודש';
            }
            else if (item.to != 0 && item.from < item.to) {
                item.priceText = 'מחודש ' + item.from + ' עד חודש ' + item.to;
                item.totalPrePriceText = 'סה"כ חיוב חודשי ' + item.priceText;
                item.totalPriceText = 'לחודש';
            }
            else if (item.to != 0 && item.from == item.to) {
                const monthsText = ['ראשון', 'שני', 'שלישי', 'רביעי']
                item.priceText = 'חיוב חודשי בחודש ה' + (item.from < 4 ? monthsText[item.from - 1] : item.from);
                item.totalPrePriceText = 'סה"כ ' + item.priceText;
                item.totalPriceText = 'לחודש';
            }
            return item;
        });
    }
    else {
        priceItems = [];
    }
    return priceItems;
}

function getProductWorldList(packageList) {
    let productWorldList = packageList?.reduce((accumulator, item) => {
        // Check if an entry with the worldName already exists in the accumulator
        let existingEntry = accumulator.find(entry => entry.name === item.worldName);

        if (existingEntry) {
            // If an entry exists, add the product details to its productList
            existingEntry.productList.push({ name: item.name, count: item.count });
        } else {
            // If not, create a new entry with the worldName and productList
            accumulator.push({
                name: item.worldName,
                productList: [{ name: item.name, count: item.count }]
            });
        }

        return accumulator;
    }, []);

    return productWorldList;

}

function checkSubscriber(subscriber, thunkAPI) {
    thunkAPI.dispatch(setSelectedSubscriber(subscriber));
    if (!subscriber.isJetCustomer) {
        thunkAPI.dispatch(reportDWH({ actionType: 'GetTvUsers', status: 'Ongoing', messageText: 'No JET Customer' }));
        thunkAPI.dispatch(setErrorPage({ isDisplay: true, id: '0', type: 'isNotJetCustomer', isOpenWorkOrder: true, description: 'not allowed' }));
    }
    else if (!subscriber.isActive) {
        thunkAPI.dispatch(setErrorPage({ isDisplay: true, id: '0', type: 'notAllowed', isOpenWorkOrder: true, description: 'not allowed' }));
    }
    else if (subscriber.hasDebt && subscriber.hasPaymentMethodIssue) {
        thunkAPI.dispatch(setErrorPage({ isDisplay: true, id: '0', type: 'hasDebtAndHasPaymentMethodIssue', isOpenWorkOrder: true, description: 'has debt and has payment method issue' }));
    }
    else if (subscriber.hasDebt) {
        thunkAPI.dispatch(setErrorPage({ isDisplay: true, id: '0', type: 'hasDebt', isOpenWorkOrder: true, description: 'has debt' }));
    }
    else if (subscriber.hasPaymentMethodIssue) {
        thunkAPI.dispatch(setErrorPage({ isDisplay: true, id: '0', type: 'hasPaymentMethodIssue', isOpenWorkOrder: true, description: 'has payment method issue' }));
    }
    else {
        thunkAPI.dispatch(getCatalogAsync())
    }

}

function isSelfCarePackageExist(packages, selfCarePackage) {
    const existWorld = packages.find(x => x.isPremiumPackagesWorld && x.premiumPackages.some(y => y.name == selfCarePackage.name));
    const existVasList = packages.find(x => x.vasList?.length > 0 && x.vasList.some(y => y.name == selfCarePackage.name));
    const existPackage = packages.find(x => x.name == selfCarePackage.name);
    return existPackage || existVasList || existWorld;
}

